/* PDP bottle fit (v399, desktop only). The 60 ml bottle's cap and base line up with the top and bottom of the right
   rail (.pv-buy), and it sits centred in the space left of the rail. The 20 ml keeps its true size against the 60 ml
   (91.3 mm vs 112.5 mm tall) on the same base line.
   The PNGs carry transparent padding, so the bottle's real edges are read from the alpha channel once per image
   (alpha-scan law). The rail is measured once with everything closed and cached per width, so opening an
   accordion or the preorder form never makes the bottle jump. Theme copy: assets/mz-pdp-bottle-fit.js. */
(function () {
  var reveal = document.querySelector('.pv-reveal.pv-v2'), bottle = reveal && reveal.querySelector('.pv-bottle:not(.set)');
  var img = bottle && bottle.querySelector('img'), rail = reveal && reveal.querySelector('.pv-buy');
  if (!img || !rail) return;
  var mq = matchMedia('(min-width:60.0625rem)'), boxes = {}, target = null, targetW = 0;
  var R20 = 91.3 / 112.5;

  // opaque bounds of an image as fractions of its natural size (scanned on a 1/4-size canvas)
  function bounds(src, cb) {
    if (boxes[src]) return cb(boxes[src]);
    var im = new Image(); im.onload = function () {
      var w = Math.max(1, im.naturalWidth >> 2), h = Math.max(1, im.naturalHeight >> 2), c = document.createElement('canvas'); c.width = w; c.height = h;
      var g = c.getContext('2d'); g.drawImage(im, 0, 0, w, h);
      var d; try { d = g.getImageData(0, 0, w, h).data; } catch (e) { return cb(null); }
      var x0 = w, y0 = h, x1 = 0, y1 = 0;
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) if (d[(y * w + x) * 4 + 3] > 24) {
        if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
      }
      cb(boxes[src] = { x0: x0 / w, x1: (x1 + 1) / w, y0: y0 / h, y1: (y1 + 1) / h, ar: im.naturalWidth / im.naturalHeight });
    };
    im.src = src;
  }
  // the rail's resting box (everything closed), relative to the reveal; cached per viewport width
  function measure() {
    if (target && targetW === innerWidth) return target;
    var rr = rail.getBoundingClientRect(), vr = reveal.getBoundingClientRect();
    targetW = innerWidth;
    return (target = { top: rr.top - vr.top, bottom: rr.bottom - vr.top, railLeft: rr.left - vr.left, height: vr.height });
  }
  function fit() {
    if (!mq.matches) { bottle.style.cssText = ''; return; }
    var t = measure(), src = img.currentSrc || img.src, is20 = img.classList.contains('is20');
    bounds(src, function (b) {
      if (!b) return;
      var T = (t.bottom - t.top) * (is20 ? R20 : 1);                      // the bottle's visible height
      var rh = T / (b.y1 - b.y0), rw = rh * b.ar;                          // rendered image size
      var boxH = rh / Math.min(1, 0.6 / b.ar);                             // .pv-bottle is aspect .6, image is contain + bottom
      var boxBottom = t.bottom + rh * (1 - b.y1);                          // opaque base sits on the rail's bottom
      var cx = t.railLeft / 2 - rw * ((b.x0 + b.x1) / 2 - 0.5);            // opaque centre on the left area's centre
      bottle.style.cssText = 'height:' + boxH + 'px;bottom:' + (t.height - boxBottom) + 'px;left:' + cx + 'px;--bs:1;--by:0%';
    });
  }
  function refit() { target = null; fit(); }
  if (img.complete) fit(); else img.addEventListener('load', fit, { once: true });
  img.addEventListener('load', fit);                                       // the 60 / 20 swap changes the src
  new MutationObserver(fit).observe(img, { attributes: true, attributeFilter: ['class'] });
  var tid; addEventListener('resize', function () { clearTimeout(tid); tid = setTimeout(refit, 120); });
  if (document.fonts) document.fonts.ready.then(refit);                    // the rail's height settles once fonts land
})();
